import React, { useState } from 'react';
import useDatePicker from '../../../hooks/useDatePicker';
import { Stack, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Iconify from '../../../components/Iconify';
import { FormattedMessage } from 'react-intl';
import { copyTrainingsInWeek } from '../services/trainingsService';
import { useSnackbar } from 'notistack';
import { useAuth } from '../../../contexts/authContext';
import PropTypes from 'prop-types';
import BackDropLoader from '../../../components/BackDropLoader';

export default function CopyTrainings({ onClose }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  
  const handleButtonClick = () => {
    setIsOpen(true);
  };
  
  const handleDatePickerClose = () => {
    setIsOpen(false);
  };
  
  const handleWeekSelect = (date) => {
    const dayOfWeek = date.getDay();
    const weekStart = new Date(date);
    const diff = (dayOfWeek === 1 ? 0 : 1 - dayOfWeek); // Adjust for Monday start
    weekStart.setDate(date.getDate() + diff); // Add the day difference to the selected date
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6); // Add 6 days to get the end of the week
    weekEnd.setHours(23, 59, 59, 999); // Set the time to 23:59:59.999
    setSelectedDate(weekStart);
  };

  const handleWeekSelectTo = (date) => {
    const dayOfWeek = date.getDay();
    const weekStart = new Date(date);
    const diff = (dayOfWeek === 1 ? 0 : 1 - dayOfWeek); // Adjust for Monday start
    weekStart.setDate(date.getDate() + diff); // Add the day difference to the selected date
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6); // Add 6 days to get the end of the week
    weekEnd.setHours(23, 59, 59, 999); // Set the time to 23:59:59.999
    setSelectedDateTo(weekStart);
  };
  
  const handleFormSubmit = () => {
    sendDatesToBackend(selectedDate, selectedDateTo);
    setIsOpen(false);
  };
  
  const sendDatesToBackend = async (selectedDate,selectedDateTo, actions) => {
    if (selectedDate && selectedDateTo) {
      const weekEnd = new Date(selectedDate+'z');
      const weekStart = new Date(selectedDate+'z');
      weekEnd.setDate(weekEnd.getDate() + 6); // Add 7 days to get the end of the week
      weekEnd.setHours(23, 59, 59, 999); // Set the time to 23:59:59.999

      const weekEndTo = new Date(selectedDateTo+'z');
      const weekStartTo = new Date(selectedDateTo+'z');
      weekEndTo.setDate(weekEndTo.getDate() + 6); // Add 7 days to get the end of the week
      weekEndTo.setHours(23, 59, 59, 999); // Set the time to 23:59:59.999

      const userId = auth.user.id;
        
      // Make an API call or use your preferred method to send the dates to the backend
      // Example:
      const data = {
        start: weekStart.toISOString(),
        end: weekEnd.toISOString(),
        toStart: weekStartTo.toISOString(),
        toEnd: weekEndTo.toISOString(),
        userId: userId
      };

      try {
        setLoading(true);
        await copyTrainingsInWeek(data);
        enqueueSnackbar(<FormattedMessage id='copytrainings.copy.msg.success' defaultMessage='Trainings successfully copied' />, {
          variant: 'success',
        });
      } catch (error) {
        enqueueSnackbar(<FormattedMessage id='copytrainings.copy.msg.fail' defaultMessage='Failed to copy trainings' />, {
          variant: 'error',
        });
        actions.setSubmitting(false);
      }
      setLoading(false);
      onClose();
    }
  };

  const DatePicker = useDatePicker();
  
  return (
    <>
      <BackDropLoader open={loading} />
      <Stack spacing={3}>
        <Button 
          variant="contained"
          startIcon={<Iconify icon="eva:copy-outline" />}
          onClick={handleButtonClick}>
          <FormattedMessage id='common.validation.button.copytrainings.dialog' defaultMessage='Copy trainings' />
        </Button>

        <Dialog open={isOpen} onClose={handleDatePickerClose}>
          <DialogTitle>
            <FormattedMessage id='common.validation.button.copytrainings.select' defaultMessage='Copy trainings' />
          </DialogTitle>
          <DialogContent>
            <DialogTitle><FormattedMessage id='common.validation.button.copytrainings.selectFrom' defaultMessage='Copy trainings from week' /></DialogTitle>
            <DatePicker
              value={selectedDate}
              onChange={handleWeekSelect}
              renderInput={(props) => <TextField {...props} />}
            />
          </DialogContent>
          <DialogContent>
            <DialogTitle><FormattedMessage id='common.validation.button.copytrainings.selectTo' defaultMessage='Copy trainings to week' /></DialogTitle>
            <DatePicker
              value={selectedDateTo}
              onChange={handleWeekSelectTo}
              renderInput={(props) => <TextField {...props} />}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDatePickerClose}>
              <FormattedMessage id='common.validation.button.copytrainings.cancel' defaultMessage='Cancel' />
            </Button>
            <Button onClick={handleFormSubmit}>
              <FormattedMessage id='common.validation.button.copytrainings.copy' defaultMessage='Copy' />
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </>
  );
}

CopyTrainings.propTypes = {
  onClose: PropTypes.func.isRequired,
  style: PropTypes.object
};